module.exports = __webpack_public_path__ + "img/fond_4-copy_1.a4b91f92.jpg";